<script lang="ts" setup>
import { provide, computed } from 'vue';
import { useArticlesStore } from '#imports';
import { useAsyncData } from '#imports';

const articlesStore = useArticlesStore();

// 1. Fetch initial 9 articles on the server (matches standard grid size)
// The key 'initial-home-articles' ensures data is transferred to the client
const { data: initialData } = await useAsyncData(
  'initial-home-articles',
  async () => {
    const res = await articlesStore.fetchArticles(9);
    return res;
  },
);

// 2. Immediate hydration check
// If we have data from the server but the store is empty (can happen in some edge cases),
// we populate it before rendering the slots.
if (initialData.value && articlesStore.articles.length === 0) {
  articlesStore.addArticles(initialData.value.data || []);
}

// Provide data to child components
provide(
  'articlesData',
  computed(() => articlesStore.getRichArticles),
);
provide(
  'latestArticles',
  computed(() => articlesStore.getLatestRichArticles(5)),
);
</script>

<template lang="pug">
.app.layout-home
  slot
  EcreativOrganismsArgumentsModal
  EcreativMoleculesGoTop
</template>
